import { render, staticRenderFns } from "./McompatibilidadGrid.vue?vue&type=template&id=0e243231"
import script from "./McompatibilidadGrid.vue?vue&type=script&lang=js"
export * from "./McompatibilidadGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports